/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RestResponse } from "../modules/orderformlib/models/api.io";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ApiHeaders } from "./headers";

@Injectable()
export class DocumentProvider  {

  constructor(
    private http: HttpClient
  ){}

  downloadDocument(id: string, docId: string): Observable<any> {
    return this.http.get(`${environment.API_URL}/api/documents/${id}/download/${docId}`, ApiHeaders.getOptionsPlain())
      .pipe(catchError(this.parseErrorBlob));
  }

  downloadDocumentArchive(id: string, docId: string): Observable<any> {
    return this.http.get(`${environment.API_URL}/api/documents/${id}/download/${docId}/zip`, ApiHeaders.getOptionsPlain())
      .pipe(catchError(this.parseErrorBlob));
  }

  voidDocument(id: string, docId: string): Observable<RestResponse> {
    return this.http.delete<RestResponse>(`${environment.API_URL}/api/documents/${id}/void/${docId}`, ApiHeaders.getOptions());
  }

  sendReminder(id: string, docId: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/documents/${id}/remind/${docId}`, null, ApiHeaders.getOptions());
  }

  // parseErrorBlob() - Parse blob error.
  private parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (): any => {
        const returnError: any = err;
        returnError.json = JSON.parse(reader.result as any);
        observer.error(returnError);
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}
